import waveIcon from '@/presentation/assets/wave-icon.png'

interface GreetingProps {
  nickname?: string | null
}

export function Greeting(props: GreetingProps) {
  return (
    <div className='flex w-full flex-col px-[20px] pt-[26px]'>
      <div className='flex w-full items-center justify-between'>
        <div className='flex items-center gap-[6px]'>
          <img className='size-[18px]' src={waveIcon} alt='' />
          <p
            className='font-black text-[15px] leading-[18px] text-[#1a1a1a] not-italic'
            data-testid='greeting-text'
          >
            Hi!
          </p>
        </div>
      </div>

      <p
        className='mt-[8px] font-black text-[22px] leading-[26px] text-[#1a1a1a] not-italic'
        data-testid='username'
      >
        {props.nickname}
      </p>
    </div>
  )
}
